<span class="am-flex-align am-flex-shrink-0 relative">
  <span class="circle-xxl am-flex-center color-white font-xs font-500 uppercase b-width-2" [ngClass]="[room | avatarColor, room?.owner?.isOnline ? 'b-green' : 'b-secondary-grey']">{{ room?.owner?.initials }}</span>
  <span class="absolute bottom-0 right-0 circle-s circle-i b-white b-width-2" [ngClass]="room?.owner?.isOnline ? 'bg-green' : 'bg-secondary'"></span>
</span>

<span class="am-flex-column am-flex-1 width-min-0">
  <span class="ellipsis font-s font-500 color-blue" [title]="room?.roomName">{{ room?.roomName }}</span>
  <span class="tooltip-hover am-flex-align width-max-content font-xs color-secondary-grey pointer">
    <span class="word-no-wrap">{{ room?.owner?.isOnline ? 'Online' : 'Offline' }} · {{ room?.participants?.length }} Teilnehmer</span>
    <div class="web-tooltip bottom bottom-sm width-250 white b-radius-wide shadow font-s">
      <span class="am-flex-align gap-xs height-36 pl-xxs pr-xxs">
        <span class="font-500 color-title-grey">{{ room?.participants?.length }} Teilnehmer</span>
        <span class="mla">{{ onlineCount }} online</span>
      </span>
      <span class="bt-grey mt-xxs mb-xxs ml-xxs mr-xxs"></span>
      @for (participant of room?.participants; track participant.id) {
        <span class="am-flex-align gap-xs height-36 pl-xxs pr-xxs b-radius">
          <span class="relative am-flex-align am-flex-shrink-0">
            <span class="circle-xl am-flex-center color-white font-xs font-500 uppercase" [ngClass]="participant | avatarColor">{{ participant.initials }}</span>
            <span class="absolute bottom-0 right-0 circle-10 circle-i b-white b-width-2" [ngClass]="isMe(participant) || participant.isOnline ? 'bg-green' : 'bg-secondary'"></span>
          </span>
          <span class="am-flex-column am-flex-1 width-min-0">
            <span class="ellipsis font-s color-title-grey" [class.font-500]="isMe(participant)" [title]="participant.fullName">{{ participant.fullName }}</span>
          </span>
          @if (isMe(participant)) { <span class="am-flex-shrink-0 pl-xxs pr-xxs b-grey color-secondary-grey font-xs font-500">Ich</span> }
        </span>
      }
    </div>
  </span>
</span>

<span class="am-flex-align am-flex-shrink-0">
  <span class="relative am-flex-center am-flex-shrink-0">
    <span class="am-flex-center font-l-i icon-dots p-xs b-radius hover-bg-soft-blue" [ngClass]="menuOpen ? 'bg-light-blue color-blue' : ''" role="button" aria-label="Mehr" [attr.aria-expanded]="!!menuOpen" (click)="toggleMenu()"></span>
    @if (menuOpen) {
      <div class="absolute top-full right-0 z-3 mt-xxs width-165 am-flex-column bg-white b-grey b-radius-wide shadow p-xxs font-s">
        <span class="am-flex-align gap-xs height-36 pl-xs pr-xs b-radius hover-active-bg" (click)="readAll()">
          <span class="am-flex-center icon-ticks font-l"></span>
          <span>Alles lesen</span>
          @if (room?.unreadMessagesCount) { <span class="mla am-flex-center height-18 width-min-20 pl-xxs pr-xxs b-radius-wide bg-blue color-white roboto">{{ room.unreadMessagesCount > 99 ? '99+' : room.unreadMessagesCount }}</span> }
        </span>
        <span class="bt-grey mt-xxs mb-xxs ml-xxs mr-xxs"></span>
        <span class="am-flex-align gap-xs height-36 pl-xs pr-xs b-radius hover-active-bg color-red" (click)="leave()">
          <span class="am-flex-center icon-exit font-l"></span>
          <span>Chat verlassen</span>
        </span>
      </div>
    }
  </span>
  <span class="am-flex-center am-flex-shrink-0 icon-cross font-l p-xs b-radius hover-bg-soft-red" title="Chat schließen" (click)="close()"></span>
</span>
